// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"981b7463","239":"b8b02c1a","455":"83049ea2"}[chunkId] + ".chunk.js";
};